import React, { useState, useEffect ,useRef} from 'react';
import { Button, Table, Spin, DatePicker, Popover, Select, Input, Form ,Space} from 'antd';
import { SearchOutlined, RedoOutlined, EyeOutlined ,HomeOutlined} from '@ant-design/icons';
import { Config } from '../../public/js/config';
import Audit from '../../component/audit/audit';//審核彈框
import moment from 'moment';//日期格式化导包
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import './operationLogManage.css';
import Message from '../../component/message/message';

const { Option } = Select;

const OperationLogManage = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const tableColumns = {
        userCode: "user_code",
        funcName: "func_name",
        operationTime: "operation_time"
    }

    useEffect(() => {
        var d = new Date();
        d = d.setDate( d.getDate() - 1);
        let newModel = JSON.parse(JSON.stringify(searchModel));
        newModel.startDate = moment(new Date(d), Config.dateFormatALL);
        newModel.endDate = moment(new Date(), Config.dateFormatALL);
        setSearchModel(newModel);
        form.setFieldsValue({
            startDate: moment(new Date(d), Config.dateFormatALL),
            endDate: moment(new Date(), Config.dateFormatALL),
        });
    }, []);

    const submit = () => {
        search(pageSize, 1, "N", true);
    }

    /**查詢用戶信息列表 方法 */
    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        messageShowHandler();
        clearSelect();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        }else{
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("operationLogManage/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    /**用戶信息 查詢change方法 */
    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newModel =>{
            return {...newModel,...{[k]:e}};
        });
    }

    const reset = () => {
        var d = new Date();
        d = d.setDate( d.getDate() - 1);
        let newModel = JSON.parse(JSON.stringify(searchModel));
        newModel.startDate = moment(new Date(d), Config.dateFormatALL);
        newModel.endDate = moment(new Date(), Config.dateFormatALL);
        newModel.operationType = "";
        newModel.userCode = "";
        newModel.loginIpAddress = "";
        newModel.funcName = "";
        newModel.status="";
        setSearchModel(newModel);
        form.setFieldsValue({
            startDate: moment(new Date(d), Config.dateFormatALL),
            endDate: moment(new Date(), Config.dateFormatALL),

        });
        messageShowHandler();
        clearSelect();
        /* setSearchModel({operationType:""}); */
        setOldSearchModel({});
        setTablesCount(0);
        setPageSize(20);
        setTables([]);
        /* search(pageSize, 1, "N"); */
    }

    /**審核查看 */
    const audit = () => {
        messageShowHandler();//清空提示信息
        if (checkboxState == null || checkboxState.length !== 1) {
            errFrameShow("error", trans.selectiveData[Config.backLang]);
            return;
        }
        setAuditModel(checkboxState[0]);
        setIsAudit(true);
    }
    /**審核彈框的取消按鈕 */
    const auditCancel = () => {
        setIsAudit(false);
    }

    const checkStartDate = (rule, value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.startDateNoIsNull[Config.backLang]);
        } else {
            if (Base.isNotEmpty(searchModel.endDate) && Base.afterDate(value, searchModel.endDate)) {
                return Promise.reject(trans.startDateMax[Config.backLang]);
            }
            return Promise.resolve();
        }
    }

    const checkEndDate = (rule, value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.endDateNoIsNull[Config.backLang]);
        } else {
            if(Base.isNotEmpty(searchModel.startDate) && Base.afterDate(searchModel.startDate, value)){
                return Promise.reject(trans.endDateMin[Config.backLang])
            }
            return Promise.resolve();
        }
    }
    
    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //列表选中记录
    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }
    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: trans.userCode[Config.backLang],
            dataIndex: 'userCode',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userCode') },
        },
        {
            title: trans.funcName[Config.backLang],
            dataIndex: 'funcName',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'funcName') },
            render: (text, record) => {
                return (
                    Base.isNotEmpty(text) ? text : (record.operationType === 'LOGIN' ? trans.userLogin[Config.backLang] : (record.operationType === 'LOGINOUT' ? trans.userLoginOut[Config.backLang] : ""))
                );
            }
        },
        {
            title: trans.status[Config.backLang],
            dataIndex: 'status',
        },
        {
            title: trans.operationType[Config.backLang],
            dataIndex: 'operationType',
            render: (text) => ContextHandler.getMapValue('operationTypeList', text)
        },
        {
            title: trans.operationContent[Config.backLang],
            dataIndex: 'operationContent',
            className: 'tableWidth30',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "operationLogManageContent">{text}</div>
            </Popover>
        },
        {
            title: trans.operationTime[Config.backLang],
            dataIndex: 'operationTime',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'operationTime') },
            render: (text) => moment(text).format(Config.dateFormatALL)
        },
        {
            title: trans.loginIpAddress[Config.backLang],
            dataIndex: 'loginIpAddress',
        }
    ];
    /*eslint-enable*/

    const rowSelection = {
        type: 'radio',
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.sysManage[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 错误信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                {/* 審核彈框 */}
                <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                <Spin size="large" spinning={isLoad} tip={trans.search2[Config.backLang]}>
                    <div className='systabls'>
                        <Form form={form} onFinish={submit}>
                            <div className='sysRow'>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.userCode[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.userCode[Config.backLang]} maxLength={6} 
                                            onChange={(e) => searchChange('userCode', e.target.value)}
                                            value={searchModel.userCode || ''}
                                            onKeyDown = {(e) => e.key == "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.operationTime[Config.backLang]}</div>
                                    <div className="sysSerchInputTime">
                                        <Form.Item
                                            name="startDate"
                                            rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                { required: true, validator: checkStartDate },
                                            ]}>
                                            <DatePicker placeholder={trans.startTime[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                allowClear={true}
                                                showTime={true}
                                                onChange={(value) => searchChange("startDate", value)}
                                                format={Config.dateFormatALL} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitleTime">{trans.zhi[Config.backLang]}</div>
                                    <div className="sysSerchInputTime">
                                        <Form.Item
                                            name="endDate"
                                            rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                { required: true, validator: checkEndDate },
                                            ]}>
                                            <DatePicker placeholder={trans.endTime[Config.backLang]}
                                                className="parts-numberInput datePickerAllWidth"
                                                allowClear={true}
                                                showTime={true}
                                                onChange={(value) => searchChange("endDate", value)}
                                                format={Config.dateFormatALL} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.loginIpAddress[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.loginIpAddress[Config.backLang]} maxLength={40} 
                                            onChange={(e) => searchChange('loginIpAddress', e.target.value)}
                                            value={searchModel.loginIpAddress || ''} 
                                            onKeyDown = {(e) => e.key == "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.funcName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder={trans.funcName[Config.backLang]} maxLength={40} 
                                            onChange={(e) => searchChange('funcName', e.target.value)}
                                            value={searchModel.funcName || ''} 
                                            onKeyDown = {(e) => e.key == "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.operationType[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select  placeholder={trans.operationType[Config.backLang]} value={searchModel.operationType}
                                            className="sysSelect"
                                            onChange={(e) => searchChange('operationType', e)}>
                                            <Option value=""></Option>
                                            {context.operationTypeList.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles">{trans.result[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select  placeholder={trans.result[Config.backLang]} value={searchModel.status}
                                            className="sysSelect"
                                            onChange={(e) => searchChange('status', e)}>
                                            <Option value=""></Option>
                                            {context.resultTypeList.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit" hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={() => reset()} icon={<RedoOutlined />} >{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </Form>
                        <div className="sysLineEight" />
                        <Space size={[5, 5]} wrap className="sysButtonRelative">
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => { audit() }} hidden={Config.funcInfo.canAudit === "N"} icon={<EyeOutlined />}>{trans.audit[Config.backLang]}</Button>
                        </Space>
                        <div className="sysTable" id="tableOne">
                            <Table
                                rowSelection={rowSelection} //选择
                                rowKey="operationLogId"
                                scroll={{ x: 1400 }}
                                columns={columns} //列名
                                dataSource={tables} //数据
                                pagination={{  //分页
                                    showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                    onChange: onChange,                        //上页下页或者跳页方法
                                    onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                    total: tablesCount,                  //总共多少条数据
                                    current: current,                    //当前页
                                    pageSize: pageSize,                  //每页显示多少条数据
                                    defaultCurrent: 1,                              //默认当前页为1
                                    size:"small"
                                }}
                                onRow={(record) => {
                                    return {
                                        onClick: event => Base.selectRadioRowNew.call(this,record, "operationLogId" ,selectedRowKeys, setCheckboxState, setSelectedRowKeys), // 点击行
                                    };
                                }}
                                onChange={handleTableChange}
                            />
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default OperationLogManage;